import { PropsWithChildren, useEffect } from "react";
import { ProductAction } from "../product-manager/types";

export interface ProductActionHandlerProps extends PropsWithChildren {
    pendingActionCount: number | undefined;
    checkoutId: number | undefined;
    getActions: (checkoutId: number) => Promise<{ checkoutId: number }[]>;
    onTargetedActionExists: (targetedActions: any[]) => void;
}

export function ProductActionHandler({
    children,
    checkoutId = undefined,
    getActions = async (checkoutId: number) => [],
    onTargetedActionExists = (targetedActions: ProductAction[]) => { return; },
    pendingActionCount = undefined
}: ProductActionHandlerProps) {

    useEffect(() => {
        let intervalRef: NodeJS.Timeout | undefined = undefined;
        if (checkoutId && pendingActionCount) {
            intervalRef = setInterval(() => {
                getActions(checkoutId).then((actions) => {
                    const targetedActions = actions.filter((action) => action.checkoutId === checkoutId)
                    if (targetedActions?.length === pendingActionCount) {
                        onTargetedActionExists(targetedActions)
                    }
                })
            }, 5000)
        }
        return () => intervalRef && clearInterval(intervalRef)
    }, [checkoutId, pendingActionCount])

    return <>
        {children}
    </>

}